import React, { useEffect } from "react";
import LinkButton from "components/LinkButton";
import ProgressMeter from "components/ProgressMeter/ProgressMeter";
import { campaignEndTimeDisplay } from "helpers/campaignEndTimeDisplay";
import { PropTypes } from "prop-types";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import { IconClock } from "components/Icon";
import useGetCampaignCountdown from "hooks/useGetCampaignCountdown";
import SellingPointsWell from "../SellingPointsWell";

const CampaignSideBar = ({
  viewport,
  campaign,
  entity,
  ownerName,
  paymentUrl,
  shouldShowMatchedGiving,
}) => {
  const buttonSize = viewport === "mobile" ? "desktop" : "largev2";
  const { translate: t } = useLanguageProvider();
  const {
    campaignEndsTime, isLessThanOneDay, setEndTime, getBrowserEndTimeString, hasEnded,
  } = useGetCampaignCountdown();

  useEffect(() => {
    if (campaign) {
      setEndTime(campaign.duration.finishAtUtc);
    }
  }, [campaign, setEndTime]);

  if (!campaign) {
    return null;
  }

  const campaignIsActive = campaign.status === "Live" || campaign.status === "Approved" || campaign.status === "Infinity";
  const shouldAllowDonations = campaignIsActive && !(hasEnded && !campaign.duration.isInfinityMode);

  return (
    <>
      <div className="well">
        <div className="campaign-container__animated-total">
          <div className="campaign-container__progress-bar">
            {entity.collectedTargetProgressPercentHidden ? (
              <div className="progress-hidden">
                This campaign has chosen to hide details of funds raised for privacy or safety
                reasons.
              </div>
            ) : (
              <ProgressMeter
                currency={campaign.target.currency}
                currencySymbol={campaign.target.currencyNode.symbol}
                raised={entity.raised || 0}
                target={+entity.target}
                hideTotal={entity.collectedTargetHidden}
                fixedPercentage={
                  entity.collectedTargetHidden && entity.collectedTargetProgressPercent
                }
              />
            )}
          </div>
          <LinkButton
            href={paymentUrl}
            look="primary"
            isBold
            isDisabled={!shouldAllowDonations}
            size={buttonSize}
            data-test={`campaign-donate-button-${viewport}`}
            className="campaign-container__donate-button"
          >
            {shouldAllowDonations
              ? shouldShowMatchedGiving
                ? t("Double your donation")
                : t("Donate now")
              : t("Donations closed")}
          </LinkButton>
          {!hasEnded && campaignEndTimeDisplay(campaign.status, campaignEndsTime) && (
            <>
              <p className="campaign-container__countdown --notification">
                <span
                  className={isLessThanOneDay ? "timer --closing-soon" : "timer"}
                  data-test="campaign-countdown"
                >
                  <IconClock height="1.75rem" className="clock-icon" />
                  {" "}
                  {t("Ends in")}
                  {" "}
                  {campaignEndsTime}
                </span>
              </p>

              <p className="campaign-container__end-date" data-test="campaign-countdown-date">
                {getBrowserEndTimeString(campaign.duration)}
              </p>
            </>
          )}
        </div>
      </div>
      <div className="well">
        <SellingPointsWell ownerName={ownerName} />
      </div>
    </>
  );
};

export default CampaignSideBar;

CampaignSideBar.propTypes = {
  viewport: PropTypes.string,
  campaignEndsTime: PropTypes.string,
  campaign: PropTypes.object,
  entity: PropTypes.object.isRequired,
  ownerName: PropTypes.string,
  paymentUrl: PropTypes.string.isRequired,
  shouldShowMatchedGiving: PropTypes.bool,
};
